// Cards data for Blood on the Clocktower
// This file centralizes the card definitions to avoid duplication across components

export const cards = [
  { name: 'ability?', text: 'Use Your Ability?' },
  { name: 'choice', text: 'Make a choice' },
  { name: 'demon', text: 'This is the Demon' },
  { name: 'minions', text: 'These are your Minions' },
  { name: 'bluffs', text: 'These characters are not in Play:' },
  { name: 'selected_you', text: 'This character selected you:' },
  { name: 'player_is', text: 'This player is:' },
  { name: 'you_are', text: 'You are:' },
  { name: 'nominate?', text: 'Did you nominate today?' },
  { name: 'vote?', text: 'Did you vote today?' }
]